import {
  BrowserRouter,
  Routes,
  Route,
} from "react-router-dom";

import Login from "./Login";
import Layout from "./Layout";
import Dashboard from "./Dashboard";
import Facturacion from "./Facturacion";
import Productos from "./Productos";
import Companies from "./Companies";
import LoginEmpresa from "./LoginEmpresa";
import Profile from "./Profile";
import Settings from "./Settings";
import ChangePassword from "./ChangePassword";
import Usuarios from "./usuarios";

import CompanyLayout from "./CompanyLayout";
import CompanyDashboard from "./CompanyDashboard";
import CompanyUsers from "./CompanyUsers";
import CompanyClients from "./CompanyClients";
import CompanyProducts from "./CompanyProducts";
import CompanyInventory from "./CompanyInventory";
import CompanyBilling from "./CompanyBilling";
import CompanyReports from "./CompanyReports";
import CompanySettings from "./CompanySettings";
import CompanyCashRegister from "./CompanyCashRegister";
import CompanySales from "./CompanySales";
import CompanySuppliers from "./CompanySuppliers";
import CompanyPurchases from "./CompanyPurchases";
import CompanyAccounting from "./CompanyAccounting";
import CompanyBanks from "./CompanyBanks";
import {
  CompanyBrandingProvider,
} from "./CompanyBrandingContext";

import RequirePermission from "./RequirePermission";
import { PermissionProvider } from "./PermissionContext";
import CompanyCashClosings from "./CompanyCashClosings";
import CompanyPurchaseOrders from "./CompanyPurchaseOrders";
import CompanyWarehouses from "./CompanyWarehouses";
import CompanyWarehouseTransfers from "./CompanyWarehouseTransfers";
import CompanyInventoryCounts from "./CompanyInventoryCounts";
import CompanyPriceLists from "./CompanyPriceLists";
import CompanyPromotions from "./CompanyPromotions";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* =========================
            LOGIN SUPERADMIN
        ========================= */}

        <Route
          path="/"
          element={<Login />}
        />

        {/* =========================
            LOGIN EMPRESA
        ========================= */}

        <Route
          path="/:company"
          element={<LoginEmpresa />}
        />

        {/* =========================
            SISTEMA EMPRESA
        ========================= */}

        <Route
          path="/:company"
          element={
            <CompanyBrandingProvider>
              <PermissionProvider>
                <CompanyLayout />
              </PermissionProvider>
            </CompanyBrandingProvider>
          }
        >
          <Route
            path="dashboard"
            element={
              <RequirePermission permission="dashboard.view">
                <CompanyDashboard />
              </RequirePermission>
            }
          />

          <Route
            path="usuarios"
            element={
              <RequirePermission permission="users.view">
                <CompanyUsers />
              </RequirePermission>
            }
          />

          <Route
            path="clientes"
            element={
              <RequirePermission permission="customers.view">
                <CompanyClients />
              </RequirePermission>
            }
          />

          <Route
            path="productos"
            element={
              <RequirePermission permission="products.view">
                <CompanyProducts />
              </RequirePermission>
            }
          />
          <Route
            path="listas-precios"
            element={
              <RequirePermission permission="products.view">
                <CompanyPriceLists />
              </RequirePermission>
            }
          />
          <Route
            path="promociones"
            element={
              <RequirePermission permission="products.view">
                <CompanyPromotions />
              </RequirePermission>
            }
          />
          <Route
            path="inventario"
            element={
              <RequirePermission permission="inventory.view">
                <CompanyInventory />
              </RequirePermission>
            }
          />

          <Route
            path="bodegas"
            element={
              <RequirePermission permission="inventory.view">
                <CompanyWarehouses />
              </RequirePermission>
            }
          />

          <Route
            path="transferencias-bodega"
            element={
              <RequirePermission permission="inventory.view">
                <CompanyWarehouseTransfers />
              </RequirePermission>
            }
          />

          <Route
            path="conteos-fisicos"
            element={
              <RequirePermission permission="inventory.view">
                <CompanyInventoryCounts />
              </RequirePermission>
            }
          />

          <Route
            path="compras"
            element={
              <RequirePermission permission="purchases.view">
                <CompanyPurchases />
              </RequirePermission>
            }
          />

          <Route
            path="ordenes-compra"
            element={
              <RequirePermission permission="purchases.view">
                <CompanyPurchaseOrders />
              </RequirePermission>
            }
          />

          <Route
            path="ventas"
            element={
              <RequirePermission permission="sales.view">
                <CompanySales />
              </RequirePermission>
            }
          />

          <Route
            path="facturacion"
            element={
              <RequirePermission permission="billing.view">
                <CompanyBilling />
              </RequirePermission>
            }
          />

          <Route
            path="proveedores"
            element={
              <RequirePermission permission="suppliers.view">
                <CompanySuppliers />
              </RequirePermission>
            }
          />

          <Route
            path="reportes"
            element={
              <RequirePermission permission="reports.view">
                <CompanyReports />
              </RequirePermission>
            }
          />

          <Route
            path="configuracion"
            element={
              <RequirePermission permission="settings.view">
                <CompanySettings />
              </RequirePermission>
            }
          />

          <Route
            path="caja"
            element={
              <RequirePermission permission="cash.view">
                <CompanyCashRegister />
              </RequirePermission>
            }
          />
          <Route
            path="cierres-caja"
            element={
              <RequirePermission permission="cash.view">
                <CompanyCashClosings />
              </RequirePermission>
            }
          />

          <Route
            path="contabilidad"
            element={
              <RequirePermission permission="accounting.view">
                <CompanyAccounting />
              </RequirePermission>
            }
          />

          <Route
            path="bancos"
            element={
              <RequirePermission permission="banks.view">
                <CompanyBanks />
              </RequirePermission>
            }
          />
        </Route>

        {/* =========================
            SISTEMA SUPERADMIN
        ========================= */}

        <Route
          path="/"
          element={<Layout />}
        >
          <Route
            path="dashboard"
            element={<Dashboard />}
          />

          <Route
            path="facturacion"
            element={<Facturacion />}
          />

          <Route
            path="productos"
            element={<Productos />}
          />

          <Route
            path="companies"
            element={<Companies />}
          />

          <Route
            path="profile"
            element={<Profile />}
          />

          <Route
            path="settings"
            element={<Settings />}
          />

          <Route
            path="change-password"
            element={<ChangePassword />}
          />

          <Route
            path="usuarios"
            element={<Usuarios />}
          />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;